define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/table"
], function(declare,Controller,csiTable) {

	return declare(Controller, {
		/**
		 * @override
		 * Generate request for additional table rows
		 */
		process: function() {
			const view = this.widget;
			const row = view.getRefNode(this.m_element);
			let promise;

			if (view.getHierarchyState(row) == csiTable.HS_PLUS) {
				this.setProgress();
				promise = view.expandRow(row);
			} else {
				promise = view.collapseRow(row);
			}
			
			this.when(promise, () => this.postProcess(true));
		}
	});
});